module.exports = __webpack_public_path__ + "static/img/1.f34973f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/1.png
// module id = ab93
// module chunks = 0